module.exports = __webpack_public_path__ + "55c5413b149135a77f707e0b1c184b48.svg";